module.exports = __webpack_public_path__ + "images/1-i1de4daaaf0d323b6362558ce854ba84e.svg";